module.exports = {
	"textures": [
		{
			"image": "BallSim03.png",
			"format": "RGBA8888",
			"size": {
				"w": 256,
				"h": 256
			},
			"scale": 1,
			"frames": [
				{
					"filename": "102.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 388,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "107.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 373,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 17,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "108.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 367,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 33,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "112.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 210,
						"y": 349,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 49,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "115.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 195,
						"y": 347,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 65,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "116.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 191,
						"y": 348,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 81,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "119.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 173,
						"y": 342,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 97,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "59.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 397,
						"y": 113,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 113,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "90.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 211,
						"y": 317,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 129,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "97.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 222,
						"y": 359,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 145,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "100.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 387,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 161,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "103.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 387,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 177,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "105.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 383,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 193,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "110.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 356,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 209,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "57.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 431,
						"y": 172,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 225,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "58.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 417,
						"y": 141,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 241,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "60.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 374,
						"y": 89,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 161,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "69.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 103,
						"y": 96,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 177,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "72.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 51,
						"y": 178,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 193,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "86.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 183,
						"y": 317,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 209,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "88.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 200,
						"y": 314,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 225,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "92.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 216,
						"y": 328,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 241,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "94.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 337,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 1,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "53.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 436,
						"y": 300,
						"w": 12,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 17,
						"w": 12,
						"h": 14
					}
				},
				{
					"filename": "74.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 41,
						"y": 242,
						"w": 12,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 33,
						"w": 12,
						"h": 14
					}
				},
				{
					"filename": "106.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 379,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 49,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "121.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 180,
						"y": 347,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 17,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 91,
						"y": 377,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 1,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 115,
						"y": 400,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 32,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 142,
						"y": 418,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 64,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 331,
						"y": 424,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 79,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "50.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 386,
						"y": 384,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 94,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "51.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 407,
						"y": 359,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 109,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "61.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 347,
						"y": 70,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 124,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "62.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 318,
						"y": 56,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 17,
						"y": 139,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "67.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 159,
						"y": 59,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 154,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "68.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 129,
						"y": 75,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 169,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "78.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 349,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 184,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "79.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 94,
						"y": 343,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 199,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "83.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 159,
						"y": 319,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 214,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "85.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 318,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 229,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 235,
						"y": 445,
						"w": 14,
						"h": 11
					},
					"frame": {
						"x": 31,
						"y": 244,
						"w": 14,
						"h": 11
					}
				},
				{
					"filename": "87.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 191,
						"y": 316,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 47,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "91.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 213,
						"y": 323,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 16,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "93.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 333,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 1,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "95.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 341,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 31,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "96.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 349,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 62,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "101.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 389,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 77,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "104.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 386,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 92,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "109.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 226,
						"y": 361,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 107,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "111.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 217,
						"y": 353,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 122,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "113.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 345,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 33,
						"y": 137,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "114.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 200,
						"y": 346,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 152,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "117.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 188,
						"y": 349,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 77,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "118.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 181,
						"y": 346,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 49,
						"y": 46,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "120.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 177,
						"y": 345,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 49,
						"y": 61,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "122.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 349,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 16,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "123.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 181,
						"y": 347,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 64,
						"y": 1,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "135.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 121,
						"y": 226,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 31,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "169.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 356,
						"y": 297,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 92,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 393,
						"y": 106,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 107,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "170.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 350,
						"y": 308,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 122,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 71,
						"y": 350,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 137,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 172,
						"y": 432,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 167,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 300,
						"y": 436,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 182,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 361,
						"y": 406,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 197,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "52.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 424,
						"y": 331,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 212,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "54.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 442,
						"y": 269,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 227,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "56.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 440,
						"y": 204,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 242,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "70.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 81,
						"y": 121,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 152,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "71.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 149,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 76,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "76.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 51,
						"y": 307,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 64,
						"y": 46,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "77.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 65,
						"y": 340,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 64,
						"y": 61,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "80.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 112,
						"y": 336,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 16,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "81.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 130,
						"y": 329,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 79,
						"y": 1,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "82.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 148,
						"y": 322,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 31,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "84.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 167,
						"y": 319,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 91,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "89.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 209,
						"y": 313,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 106,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "98.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 370,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 121,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "99.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 220,
						"y": 379,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 136,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 442,
						"y": 284,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 167,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "132.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 122,
						"y": 264,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 182,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "140.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 145,
						"y": 168,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 197,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "147.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 121,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 212,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "149.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 243,
						"y": 118,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 227,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 429,
						"y": 160,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 242,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "154.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 304,
						"y": 133,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 167,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "157.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 334,
						"y": 156,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 77,
						"y": 151,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 413,
						"y": 131,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 76,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "163.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 368,
						"y": 223,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 79,
						"y": 46,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "172.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 335,
						"y": 328,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 79,
						"y": 61,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "177.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 282,
						"y": 361,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 91,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "179.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 257,
						"y": 366,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 106,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "181.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 232,
						"y": 366,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 121,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "182.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 364,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 78,
						"y": 136,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 59,
						"y": 165,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 182,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 51,
						"y": 188,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 197,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 56,
						"y": 312,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 212,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 66,
						"y": 336,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 227,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "55.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 444,
						"y": 237,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 242,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "73.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 210,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 90,
						"y": 166,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "75.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 275,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 91,
						"y": 151,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 446,
						"y": 253,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 92,
						"y": 76,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 446,
						"y": 222,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 93,
						"y": 16,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 237,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 94,
						"y": 1,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "63.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 287,
						"y": 47,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 31,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "64.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 255,
						"y": 42,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 106,
						"y": 16,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 432,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 107,
						"y": 1,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 440,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 45,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "124.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 176,
						"y": 347,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 59,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "127.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 148,
						"y": 321,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 92,
						"y": 91,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "129.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 134,
						"y": 300,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 73,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "134.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 120,
						"y": 239,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 108,
						"y": 45,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "137.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 127,
						"y": 202,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 108,
						"y": 59,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "151.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 268,
						"y": 121,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 109,
						"y": 30,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "158.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 342,
						"y": 166,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 1,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "168.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 361,
						"y": 286,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 15,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "178.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 269,
						"y": 365,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 92,
						"y": 105,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 370,
						"y": 85,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 92,
						"y": 119,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 287,
						"y": 46,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 92,
						"y": 133,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 163,
						"y": 58,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 181,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 138,
						"y": 71,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 104,
						"y": 166,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 117,
						"y": 86,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 147,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 266,
						"y": 443,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 107,
						"y": 87,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 203,
						"y": 441,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 73,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 268,
						"y": 443,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 123,
						"y": 44,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 328,
						"y": 426,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 124,
						"y": 29,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "65.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 43,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 123,
						"y": 58,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "66.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 191,
						"y": 48,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 137,
						"y": 1,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 403,
						"y": 368,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 137,
						"y": 15,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "125.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 166,
						"y": 339,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 107,
						"y": 101,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "126.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 157,
						"y": 331,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 107,
						"y": 115,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "128.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 141,
						"y": 311,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 107,
						"y": 129,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "130.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 129,
						"y": 289,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 195,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "131.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 125,
						"y": 277,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 209,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "133.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 121,
						"y": 252,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 223,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "136.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 124,
						"y": 214,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 237,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "138.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 132,
						"y": 190,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 104,
						"y": 195,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "139.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 138,
						"y": 179,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 180,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "141.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 153,
						"y": 159,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 104,
						"y": 209,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "142.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 162,
						"y": 150,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 104,
						"y": 223,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "143.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 172,
						"y": 142,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 104,
						"y": 237,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "144.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 183,
						"y": 135,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 118,
						"y": 194,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "145.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 194,
						"y": 129,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 161,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "146.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 206,
						"y": 125,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 143,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "148.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 231,
						"y": 119,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 175,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "150.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 256,
						"y": 119,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 121,
						"y": 101,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "152.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 281,
						"y": 124,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 87,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "153.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 293,
						"y": 128,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 135,
						"y": 72,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "155.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 315,
						"y": 140,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 121,
						"y": 115,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "156.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 325,
						"y": 148,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 121,
						"y": 129,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "159.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 350,
						"y": 176,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 138,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "160.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 356,
						"y": 187,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 139,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "161.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 361,
						"y": 199,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 138,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "162.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 365,
						"y": 211,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 152,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "164.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 369,
						"y": 236,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 152,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "165.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 369,
						"y": 249,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 118,
						"y": 208,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "166.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 368,
						"y": 261,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 118,
						"y": 222,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "167.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 365,
						"y": 274,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 118,
						"y": 236,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "171.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 343,
						"y": 319,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 132,
						"y": 189,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "173.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 326,
						"y": 337,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 157,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "174.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 316,
						"y": 345,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 134,
						"y": 143,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "175.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 305,
						"y": 352,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 171,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "176.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 294,
						"y": 357,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 135,
						"y": 101,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "180.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 244,
						"y": 367,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 136,
						"y": 86,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "183.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 207,
						"y": 361,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 149,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "184.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 195,
						"y": 357,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 152,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "185.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 184,
						"y": 351,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 153,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 345,
						"y": 68,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 152,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 194,
						"y": 48,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 166,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 99,
						"y": 103,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 166,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 83,
						"y": 122,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 135,
						"y": 115,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 69,
						"y": 143,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 135,
						"y": 129,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 357,
						"y": 411,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 132,
						"y": 203,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 382,
						"y": 391,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 132,
						"y": 217,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 421,
						"y": 342,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 132,
						"y": 231,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 434,
						"y": 314,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 146,
						"y": 185,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 440,
						"y": 191,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 157,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 46,
						"y": 213,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 148,
						"y": 143,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 45,
						"y": 263,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 171,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 49,
						"y": 288,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 149,
						"y": 100,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 256,
						"y": 42,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 150,
						"y": 85,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 225,
						"y": 43,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 163,
						"y": 71,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 297,
						"y": 438,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 166,
						"y": 43,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 235,
						"y": 444,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 167,
						"y": 29,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 317,
						"y": 55,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 166,
						"y": 56,
						"w": 12,
						"h": 11
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:45b19670e00facae31513643140fa767:c1e7ec6a167e401189eab167e022b9fc:d1528a847db85b2cd0d22fd9fa372d9a$"
	}
}
;